// extracted by mini-css-extract-plugin
module.exports =  {"bulk-panel":"_3FYHini-V6AOwlv4RNNS-X"};